import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { Bus, useAside, useTour } from '@orion.ui/orion';
import { defineAsyncComponent, ref } from 'vue';

export type TourOrderStatusEmits = {};
export type TourOrderStatusProps = {};

export default class TourOrderStatusSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = {};

	readonly _tourOrderStatus = ref<OrionTour>();

	constructor (
		private props: TourOrderStatusProps,
		private emits: TourOrderStatusEmits,
		private _aside?: OrionAside,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderStatus', this._tourOrderStatus.value);
	}

	openHelpAside () {
		return {
			callback: () => {
				return new Promise(async (resolve) => {
					useAside({
						Nested: defineAsyncComponent(() => import('@/components/order/details/OrderDetailsStatusHelper.vue')),
						size: 'lg',
					});
					setTimeout(() => {
						resolve(true);
					}, 600);
				});
			},
			label: this.$t('common.label.next'),
		};
	}

	closeAside () {
		return {
			callback: () => {
				return new Promise((resolve) => {
					Bus.emit('OrderDetailsStatusHelperSetup:closeAside');
					resolve(true);
				});
			},
			label: this.$t('common.previous'),
		};
	}

	endTourCallback () {
		Bus.emit('OrderDetailsStatusHelperSetup:closeAside');
	}

}
